import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const settingsRoutes: Routes = [
	{
		path: 'settings',
		canMatch: [roleGuard],
		data: { allowedRoles: [RoleCode.SUPER_ADMIN] },
		children: [
			{
				path: 'regions',
				loadComponent: () => import('./pages/regions-page/regions-page.component').then(c => c.RegionsPageComponent)
			},
			{
				path: 'app-settings',
				loadComponent: () => import('./pages/app-settings/app-settings-page.component').then(c => c.AppSettingsPageComponent)
			},
			{
				path: 'device-settings',
				loadComponent: () =>
					import('./pages/device-settings-page/device-settings-page.component').then(c => c.DeviceSettingsPageComponent)
			}
		]
	}
];
